import {
  Button,
  Card,
  Divider,
  HStack,
  Stack,
  Text,
  Wrap,
  WrapItem,
  Spinner,
  IconButton
} from '@mybridge/ui';
import { MatrixContext } from 'packages/mybridgev4/context/chat-context';
import { forwardRef, useContext, useEffect, useMemo } from 'react';
import { MyNetworkContext } from 'v4/components/network/context';
import { MyNetworkUserCard } from 'v4/components/network/network-card-full';
import { NetworkListingNotFound } from '../../../404';
import { MyNetworkCircleCardMenu } from '../../circle-menu';
import { SearchCardSkeleton } from 'v4/snippets/search/search-card-skeleton';
import { UserNetworkingActions } from 'v4/components/user-networking-actions';
import { MyNetworkUserCardBordered } from 'v4/components/network/network-card-new';
import InfiniteScroll from 'react-infinite-scroll-component';
import MyNetworkSearchInput from 'v4/components/network/network-search-input';
import { isMobile } from 'react-device-detect';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { getUserFullName } from 'v4/lib/commons';
import { useNumberFormatter } from '@mybridge/ui/custom-hooks/useNumberFormatter';
export const MyNetworkSecondDegreeListing = forwardRef(({ ...props }, ref) => {
  const {
    searchQuery,
    setSearchQuery,
    refetchMySecondDegreeConnections,
    mySecondDegreeConnections,
    mySecondDegreeConnectionsIsFetching,
    mySecondDegreeConnectionsIsLoading,
    userProfileInfo,
    MySecondDegreeConnectionsFetchNextPage,
    MySecondDegreeConnectionsHasNextPage,
    mySecondDegreeConnectionsCount,
    mySecondDegreeConnectionsPagingCount,
  } = useContext(MyNetworkContext);
  const { startChatSingle } = useContext(MatrixContext);
  const { t } = useTranslator();
  const { formatNumber } = useNumberFormatter();
  // useEffect(() => {
  //   if (userProfileInfo?.id) {
  //     refetchMySecondDegreeConnections?.();
  //   }
  // }, [userProfileInfo]);

  // useEffect(() => {
  //   refetchMySecondDegreeConnections?.();
    
  //   // Cleanup function to reset searchQuery when component unmounts
  //   return () => {
  //     setSearchQuery('');
  //   };
  // }, []);

  /*
  useEffect(() => {
    if (userProfileInfo?.id) {
      refetchMySecondDegreeConnections?.();
    }
    return () => {
      setSearchQuery('');
    };
  }, [userProfileInfo?.id, refetchMySecondDegreeConnections]);

  useEffect(() => {
    if (userProfileInfo?.id && searchQuery !== undefined) {
      refetchMySecondDegreeConnections?.();
    }
  }, [searchQuery, userProfileInfo?.id, refetchMySecondDegreeConnections]);
  */

  useEffect(() => {
    return () => {
      setSearchQuery('');
    };
  }, []);

  // Filter connections based on searchQuery
  const filteredSecondDegreeList = useMemo(() => {
    let filtered = mySecondDegreeConnections || [];
    if (searchQuery?.length > 0) {
      filtered = filtered.filter((user) => {
        const name = getUserFullName(user)?.toLowerCase?.();
        return name?.includes(searchQuery?.toLowerCase());
      });
    }
    return filtered;
  }, [mySecondDegreeConnections, searchQuery]);

  // Check if we have connections but no search results
  const hasConnections = (mySecondDegreeConnections?.length > 0);
  const hasNoSearchResults = hasConnections && searchQuery?.length > 0 && filteredSecondDegreeList?.length === 0;

  return (
    <>
      {mySecondDegreeConnectionsIsLoading ? (
        <HStack w="100%" justifyContent="center">
          <Spinner />
        </HStack>
      ) : (
        <>
          {/* Show header with count and search input if we have connections or if searching with no results */}
          {(hasConnections || hasNoSearchResults) && (
            <HStack w="100%" justifyContent="space-between" px={3} alignItems="center">
              <Text fontSize={['14px', '16px']} color="#868585" visibility={searchQuery?.length > 0 ? 'hidden' : 'visible'}>
                {formatNumber(mySecondDegreeConnectionsCount)}{' '}
                {!isMobile 
                  ? mySecondDegreeConnectionsCount === 1 
                    ? t('profile.connection') || 'Connection' 
                    : t('profile.connections') || 'Connections' 
                  : t('profileNetwork.secondDegreeConnections') || '2nd Degree Connections'}
              </Text>
              {!isMobile && <MyNetworkSearchInput searchType="mySecondDegree" />}
            </HStack>
          )}
          
          {isMobile && <Divider my={4} />}
          
          {/* Show connections if we have search results */}
          {filteredSecondDegreeList?.length > 0 ? (
            <InfiniteScroll
              dataLength={mySecondDegreeConnectionsPagingCount}
              next={MySecondDegreeConnectionsFetchNextPage}
              hasMore={MySecondDegreeConnectionsHasNextPage}
              loader={mySecondDegreeConnectionsIsFetching?
                <HStack pb={5} justifyContent="center" w="100%">
                  <Spinner />
                </HStack>:""
              }
              scrollableTarget="mySecondDegreeConnectionsContainer"
            >
              <Wrap id="mySecondDegreeConnectionsContainer"
                spacing={2}
                p={3}
                pt="20px" 
                overflow="auto"
                height="75vh"
                sx={{
                  scrollbarWidth: 'none', 
                  '&::-webkit-scrollbar': {
                    display: 'none',
                  },
                }}
              >
                {filteredSecondDegreeList?.map?.((cu, cuIndex) => (
                  <WrapItem
                    key={cuIndex}
                    maxW={['49%', '30%', '190px']}
                    flexGrow={['1', '1', 0]}
                    flexShrink={['1', '1', 0]}
                    flex="auto"
                  >
                    <MyNetworkUserCardBordered
                      key={cuIndex}
                      user={cu}
                      actions={
                        <UserNetworkingActions
                          user={cu}
                          justifyContent="center"
                          showHandshakeOnly
                        />
                      }
                    />
                  </WrapItem>
                ))}
              </Wrap>
            </InfiniteScroll>
          ) : (
            <>
              {/* Show "No users found" message if searching with no results */}
              {hasNoSearchResults ? (
                <HStack justifyContent="center">
                  <Stack alignItems="center">
                    <NetworkListingNotFound />
                    <Text>{t('scheduling.noUserFound') || "No User Found"}</Text>
                  </Stack>
                </HStack>
                // <HStack justifyContent="center" py={6}>
                //   <NetworkListingNotFound />
                //   <Text>{t('scheduling.noUserFound') || "No User Found"}</Text>
                // </HStack>
              ) : (
                /* Show default empty state if no connections at all */
                !hasConnections && (
                  <HStack justifyContent="center">
                    <Stack alignItems="center">
                      <NetworkListingNotFound />
                      <Text>{t('myMessages.noSecondDegreeConnection')}</Text>
                    </Stack>
                  </HStack>
                )
              )}
            </>
          )}
          
          {isMobile && <Divider my={4} />}
        </>
      )}
    </>
  );
});
